import { render } from "./MicrosoftIntegrationView.vue?vue&type=template&id=60f76b9c&scoped=true"
import script from "./MicrosoftIntegrationView.vue?vue&type=script&lang=js"
export * from "./MicrosoftIntegrationView.vue?vue&type=script&lang=js"

import "./MicrosoftIntegrationView.vue?vue&type=style&index=0&id=60f76b9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f76b9c"]])

export default __exports__